function dispatchEventStroage(){
    const signSetItem = sessionStorage.setItem
    sessionStorage.setItem = function(key,val){
        let setEvent = new Event('setItemEvent')
        setEvent.key = key
        setEvent.newVal = val
        window.dispatchEvent(setEvent)
        signSetItem.apply(this,arguments)
    }
}

export default dispatchEventStroage


// WEBPACK FOOTER //
// ./src/utils/tool.js